const footerNavGroups = [
  {
    title: '快速导航',
    links: [
      { label: '热度榜单', href: '#ranking' },
      { label: '吃瓜爆料', href: '#cards' },
      { label: '热门话题', href: '#topics' },
      { label: '焦点专题', href: '#carousel' },
      { label: '专题合集', href: '#index' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '平台介绍', href: '#about' },
      { label: '常见问答', href: '#faq' },
      { label: '联系我们', href: '#contact' },
      { label: '最新快讯', href: '#updates' },
    ],
  },
  {
    title: '更多入口',
    links: [
      { label: 'APP下载', href: '#app' },
      { label: '热门视频', href: '#media' },
      { label: '本站特色', href: '#features' },
      { label: '网友热议', href: '#comments' },
    ],
  },
];

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl md:text-2xl font-heading text-background-50 block mb-3">
              52吃瓜网
            </span>
            <p className="text-background-400 text-xs leading-relaxed mb-4">
              全网领先的娱乐八卦聚合平台，每日追踪最新爆料与黑料动态，覆盖明星恋情、综艺争议、影视内幕等热门话题，为吃瓜群众提供安全便捷的八卦浏览入口。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-links-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerNavGroups.map((group) => (
            <div key={group.title}>
              <h3 className="text-background-100 font-bold text-sm mb-4 whitespace-nowrap">
                {group.title}
              </h3>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavClick(link.href);
                      }}
                      className="text-background-400 hover:text-background-100 text-xs transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50">
          <div className="mb-4">
            <h4 className="text-background-300 text-xs font-bold mb-2 whitespace-nowrap">合作伙伴</h4>
            <p className="text-background-500 text-xs">精彩伙伴即将入驻，敬请期待</p>
          </div>
          <div className="text-background-500 text-xs leading-relaxed">
            <p>
              52吃瓜网 © {new Date().getFullYear()} 版权所有 | 本站内容仅供娱乐，请理性吃瓜，不造谣不信谣不传谣
            </p>
            <p className="mt-1">
              本站聚合的娱乐八卦与吃瓜爆料内容来源于公开信息，不代表本站立场。如有不实信息，请联系我们处理。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}